import React from 'react';
import { Reveal } from '../Reveal';
import { BookMockup } from '../BookMockup';
import { StarField } from '../StarField';
import { SacredBackground } from '../SacredBackground';
import { CTAButton } from '../CTAButton';
export const FinalCTA: React.FC = () => <section className="relative bg-navy-deep py-28 lg:py-48 overflow-hidden vignette" data-id="element-142">
    <SacredBackground data-id="element-143" />
    <StarField count={60} data-id="element-144" />

    {/* Layered glows */}
    <div className="absolute inset-0 pointer-events-none" style={{
    background: 'radial-gradient(ellipse at center, rgba(212,175,122,0.22), transparent 60%),' + 'radial-gradient(ellipse at 20% 80%, rgba(107,91,149,0.15), transparent 50%),' + 'radial-gradient(ellipse at 80% 20%, rgba(168,197,224,0.1), transparent 50%)'
  }} data-id="element-145" />

    <div className="relative max-w-5xl mx-auto px-6 lg:px-8 text-center" data-id="element-146">
      <Reveal data-id="element-147">
        <div className="flex justify-center mb-14" data-id="element-148">
          <BookMockup size="md" data-id="element-149" />
        </div>
      </Reveal>

      <Reveal delay={0.15} data-id="element-150">
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-6xl text-ivory leading-[1.05] mb-7 text-balance max-w-4xl mx-auto" style={{
        fontWeight: 300
      }} data-id="element-151">
          Tu vida puede sentirse{' '}
          <span className="italic gold-text" style={{
          fontWeight: 400
        }} data-id="element-152">
            más clara
          </span>{' '}
          cuando todas tus dimensiones comienzan a alinearse.
        </h2>
      </Reveal>

      <Reveal delay={0.2} data-id="element-153">
        <p className="text-ivory/70 text-lg leading-[1.8] font-light max-w-2xl mx-auto mb-12" data-id="element-154">
          Empieza hoy el viaje hacia una vida con más equilibrio, conciencia,
          intuición, disciplina y propósito.
        </p>
      </Reveal>

      <Reveal delay={0.25} data-id="element-155">
        <div className="flex justify-center" data-id="element-156">
          <CTAButton size="lg" pulse data-id="element-157">
            Comprar el libro ahora
          </CTAButton>
        </div>
      </Reveal>

      <Reveal delay={0.4} data-id="element-158">
        <div className="mt-20 max-w-xl mx-auto" data-id="element-159">
          <div className="divider-gold mb-7" data-id="element-160" />
          <p className="font-serif italic text-xl lg:text-2xl text-gold/90 leading-snug" style={{
          fontWeight: 400
        }} data-id="element-161">
            La armonía no se encuentra de golpe.
            <br data-id="element-162" />
            Se construye dimensión por dimensión.
          </p>
        </div>
      </Reveal>
    </div>
  </section>;